import { render, staticRenderFns } from "./SendReceiveElement.vue?vue&type=template&id=c19023aa&scoped=true&"
import script from "./SendReceiveElement.vue?vue&type=script&lang=js&"
export * from "./SendReceiveElement.vue?vue&type=script&lang=js&"
import style0 from "./SendReceiveElement.vue?vue&type=style&index=0&id=c19023aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19023aa",
  null
  
)

export default component.exports